__turbopack_context__.v({
  "legFrame": "legService-module-scss-module__VnHAVW__legFrame",
  "legFrameContainer": "legService-module-scss-module__VnHAVW__legFrameContainer",
});
